<div class="db-ecommerce-complete-setup db-platform-account-upgraded">
  <img class="mb10 fade-in" src="assets/images/icons/account_upgraded_stars.svg" alt="stars"/>
  <div class="header-content sub-header">
    <span class="animation sub-header" style="{{'--n:'+header['subheader'].length}}"
          [innerHTML]="header['subheader']"></span></div>
  <div class="header-content header" [style.line-height]="campaignInfo && !isMobile ? '48px' : '32px'">
    <span class="animation-header" style="{{'--n:'+header['header'].length}};{{'--d:'+header['subheader'].length}}"
          [innerHTML]="header['header']"></span></div>
  <div class="header-content desc">
    <span class="animation-desc"
          style="{{'--n:'+header['desc'].length}};{{'--d:'+((+header['header'].length) + (+header['subheader'].length))}}"
          [innerHTML]="header['desc']"></span></div>

  <div class="optimization-progress__list" [ngClass]="{ 'fade-in': fadeInProgressList }">
    <div *ngFor="let step of steps; let i = index"
         [ngClass]="{'done' : i < currentStep, 'loading' : i === currentStep}">

      <span [style.visibility]="i === currentStep ? 'visible' : 'hidden'" class="ds-spinner-circle"></span>

      <div class="optimization-progress__step">
        <span [ngClass]="{'next-step': i > currentStep}">{{ step }}</span>
      </div>
    </div>
  </div>

</div>



